import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Activity as ActivityIcon, AlertCircle, ArrowUpRight, CheckCircle2, FlaskConical, Megaphone, MessageSquare, Send, Upload, Zap } from "lucide-react";

const ICON = {
    import_completed: Upload,
    campaign_started: Megaphone,
    campaign_running: Megaphone,
    campaign_paused: Megaphone,
    campaign_completed: CheckCircle2,
    campaign_restarted: Megaphone,
    campaign_duplicated: Megaphone,
    campaign_archived: Megaphone,
    campaign_test_batch: FlaskConical,
    test_sms_sent: Send,
    test_email_sent: Send,
    test_failed: AlertCircle,
    delivery_spike: ArrowUpRight,
    reply: MessageSquare,
    failed_send: AlertCircle,
    opt_out: AlertCircle,
    alert: AlertCircle,
    live_mode_on: Zap,
};
const TONE = {
    success: "text-emerald-600 bg-emerald-50",
    info: "text-blue-600 bg-blue-50",
    warning: "text-amber-600 bg-amber-50",
    error: "text-rose-600 bg-rose-50",
};

export default function Activity() {
    const [items, setItems] = useState([]);
    const load = async () => {
        const { data } = await api.get("/activity", { params: { limit: 200 } });
        setItems(data);
    };
    useEffect(() => {
        load();
        const t = setInterval(load, 6000);
        return () => clearInterval(t);
    }, []);

    return (
        <div className="space-y-6" data-testid="activity-page">
            <div>
                <h1 className="text-2xl md:text-3xl font-display font-semibold tracking-tight">Activity</h1>
                <p className="text-sm text-muted-foreground mt-1">A live, chronological feed across the system.</p>
            </div>

            <div className="bg-white border border-border rounded-xl shadow-sm divide-y divide-border">
                {items.length === 0 && <div className="p-12 text-center text-muted-foreground"><ActivityIcon className="h-8 w-8 mx-auto mb-2" strokeWidth={1.5} />No activity yet.</div>}
                {items.map(a => {
                    const Icon = ICON[a.type] || ActivityIcon;
                    return (
                        <div key={a.id} className="flex items-start gap-3 px-5 py-3" data-testid={`activity-item-${a.id}`}>
                            <div className={`h-8 w-8 rounded-md flex items-center justify-center ${TONE[a.severity] || "text-gray-500 bg-gray-100"}`}>
                                <Icon className="h-4 w-4" strokeWidth={2} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="text-sm text-gray-900">{a.title}</div>
                                {a.description && <div className="text-xs text-muted-foreground">{a.description}</div>}
                            </div>
                            <div className="text-xs text-muted-foreground whitespace-nowrap">{new Date(a.created_at).toLocaleString()}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
